import JsonModel from './JsonModel'
import Patient, {PatientData} from './Patient'

export type DeviceStatus = 'active' | 'inactive'

export const STATUS_LABEL: Record<DeviceStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
}

export const STATUS_CHIP_COLOR: Record<DeviceStatus, 'success' | 'default'> = {
  active: 'success',
  inactive: 'default',
}

export const DEVICE_STATUS_FILTERS: {label: string, value: DeviceStatus | 'all'}[] = [
  {label: 'All', value: 'all'},
  {label: 'Active', value: 'active'},
  {label: 'Inactive', value: 'inactive'},
]

export type DeviceData = {
  id?: string
  udid: string
  name: string
  createdAt: Date
  status?: DeviceStatus
  patient?: PatientData
}

class Device extends JsonModel {
  id: string
  udid: string
  name: string
  createdAt: Date
  status: DeviceStatus
  patient?: Patient

  constructor(args: DeviceData) {
    super('Device', args)
    this.id = args.id || ''
    this.name = args.name
    this.udid = args.udid
    this.createdAt = args.createdAt
    this.status = args.status ?? 'active'
    if (args.patient) {
      this.patient = new Patient(args.patient)
    }
  }
}

export default Device
